var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 417.822,
    height: 280.456,
    viewBox: "0 0 417.822 280.456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002416"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 442",
    cx: 253.568,
    cy: 177.36,
    r: 103.096,
    fill: "#E7F5F8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 443",
    cx: 150.472,
    cy: 151.149,
    r: 103.096,
    fill: "#E7F5F8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 444",
    cx: 292.01,
    cy: 103.096,
    r: 103.096,
    fill: "#E7F5F8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 445",
    cx: 354.916,
    cy: 143.286,
    r: 62.906,
    fill: "#E7F5F8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 446",
    cx: 62.9061,
    cy: 164.118,
    r: 62.906,
    fill: "#E7F5F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsRight);
export default __webpack_public_path__ + "static/media/clouds-right.ce34545f67b9def258d4b72036f52135.svg";
export { ForwardRef as ReactComponent };